"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toProgressPromise = toProgressPromise;
var _progressPromise = require("@prezly/progress-promise");
function toProgressPromise(filePromise) {
  return new _progressPromise.ProgressPromise(function (resolve, reject, progress) {
    filePromise.then(resolve, reject);
    filePromise.progress(function (uploadInfo) {
      progress(uploadInfo.progress * 100, uploadInfo);
    });
  });
}